export var supportedIcons;

(function (supportedIcons) {
  supportedIcons["math"] = "math";
  supportedIcons["writing"] = "writing";
  supportedIcons["study"] = "study";
  supportedIcons["prep"] = "prep";
  supportedIcons["qna"] = "qna";
  supportedIcons["tbs"] = "tbs";
  supportedIcons["tutorsChat"] = "tutorsChat";
})(supportedIcons || (supportedIcons = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/MegaMenu/types.js
// module id = 1633
// module chunks = 11